import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast } from "../../toast";

export const update_review_status: Action<
  Ctx,
  { id?: string; review_status?: string }
> = async ({ sb }, data, params, helpers) => {
  const job_opening_id = data.id ?? params.get("id");
  if (!job_opening_id) {
    return { ok: false, error: "Missing id on row record or in URL" };
  }
  if (!data.review_status) {
    return { ok: false, error: "Missing review_status in action data" };
  }

  // Approving the review initializes pay_status to 'unpaid' (null → unpaid).
  const patch: Record<string, string> = { review_status: data.review_status };
  if (data.review_status === "approved") patch.pay_status = "unpaid";

  const { data: updated, error } = await sb
    .from("job_openings")
    .update(patch)
    .eq("id", job_opening_id)
    .is("deleted_at", null)
    .select("id")
    .maybeSingle();
  if (error) {
    toast({ variant: "error", text: "Review update failed. Try again" });
    return { ok: false, error: error.message };
  }
  if (!updated) {
    toast({ variant: "warning", text: "Job not found." });
    return { ok: false, error: "Job not found" };
  }
  helpers.removeItem((r) => r.id === job_opening_id);
  invalidate("jobs");
  toast({ variant: "success", text: "Review status updated!" });
  return { ok: true };
};
